import { callFirebaseFunction, useFirebaseFunction } from '../../../../../../services/firebaseFunctions';

export type HireRightConnectionStatus = {
  connected: boolean;
};

export const useHireRightConnectionStatus = (orgId: string, refreshKey: number) => {
  return useFirebaseFunction<HireRightConnectionStatus>(
    'hireright_getConnectionStatus',
    { orgId },
    [orgId, refreshKey]
  );
};

export const disconnectHireRight = (orgId: string) => {
  return callFirebaseFunction<{ success: true }>('hireright_disconnect', { orgId });
};
